import React, { Component } from "react";
import { URL } from "../../../utils/Constants";

class McqTestTemplate extends Component {
  state = {
    tabCloseModal: false,
  };
  componentDidMount() {
    this.props.startTimerTest();
    window.addEventListener("beforeunload", this.handleTabClose);


  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleTabClose);
  }

  handleTabClose = (event) => {
    // Cancel the event as stated by the standard
    event.preventDefault();

    const customMessage = "You have unsaved changes. Are you sure you want to leave?";
    // Chrome requires returnValue to be set
    event.returnValue = customMessage;

    // Set a flag that we need to submit on next load
    localStorage.setItem('mcqPendingSubmission', 'true');
    localStorage.setItem('mcqPendingSubmissionData', JSON.stringify(this.props.mcqTest));

    return customMessage;
  };



  // playAudio = (path) => {
  //   const fileURL = `${URL.imageSelectURL}${path}`;
  //   const a = new Audio(fileURL);
  //   a.play();
  // };

  render() {
    const mcqTest = this.props.mcqTest;
    return (
      <div>
        <div
          className="tt-widgetContent-tab-holder"
          style={{ height: "75.7vh", padding: "10px 30px" }}
        >
          <div>
            <div className="row">
              <div className="col text-center tt-mcqTestHead">
                <h4>{mcqTest.subjectName}</h4>
              </div>
            </div>
            <div className="row">
              <div className="col text-center tt-mcqTestHead">
                <h3>{mcqTest.topic}</h3>
              </div>
            </div>
          </div>
          {mcqTest.testTypeId === 1 ? (
            <div className="row tt-timerSticky">
              <div className="col text-right">
                <div className="timer" id="time">
                  {this.props.minute} : {this.props.seconds < 10 ? 0 : ""}
                  {this.props.seconds}
                </div>
              </div>
            </div>
          ) : null}

          <div className="text-right py-2">
            <strong>Full Marks: </strong>
            <span>{mcqTest.fullMarks}</span>
          </div>

          {mcqTest.mcqQuestions.map((ques, idx) => {
            return (
              // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
              <div key={idx} className="tt-mcqQuestionHolder">
                <div className="question1">
                  <span>
                    {idx + 1} {")"} {ques.question}
                  </span>{" "}
                  <span>
                    {"[ "}
                    {ques.marks} {"marks"}
                    {" ]"}
                  </span>
                </div>
                <ul className="answerOptions">
                  {ques.mcqQuestionOptions.map((opt, oIdx) => {
                    return (
                      <li
                        className="answerOption"
                        // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
                        key={oIdx}
                        onClick={
                          this.props.isSubmitted
                            ? null
                            : (e) =>
                              this.props.handleOptionClick(e, ques.id, oIdx)
                        }
                        onKeyDown={
                          this.props.isSubmitted
                            ? null
                            : (e) =>
                              this.props.handleOptionClick(e, ques.id, oIdx)
                        }
                      >
                        <input
                          type="radio"
                          name={`mcq${ques.id}`}
                          checked={opt.isSelected}
                          disabled={this.props.isSubmitted}
                        />
                        <span className="answerChoice">
                          {opt.mediaPath !== "" &&
                            opt.mediaType !== "" &&
                            !opt.optionValue ? (
                            <>
                              {opt.mediaType === "AUD" ? (
                                <figure style={{ padding: "10px" }}>
                                  <figcaption>Listen:</figcaption>
                                  {/* biome-ignore lint/a11y/useMediaCaption: <explanation> */}
                                  <audio
                                    controls
                                    src={`${URL.imageSelectURL}${opt.mediaPath}`}
                                  >
                                    <a
                                      href={`${URL.imageSelectURL}${opt.mediaPath}`}
                                    >
                                      Download audio
                                    </a>
                                  </audio>
                                </figure>
                              ) : (
                                <img
                                  src={`${URL.imageSelectURL}${opt.mediaPath}`}
                                  alt={opt.mediaPath}
                                  height={"250"}
                                  width={"250"}
                                  className="img-fluid"
                                />
                              )}
                            </>
                          ) : (
                            opt.optionValue
                          )}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
        </div>
        <div className="container-fluid mt-3">
          <div className="row">
            <div className="col text-right">
              <button
                type="button"
                className="tt-button tt-button-primary mr-3"
                onClick={this.props.submitMcqTest}
              >
                Submit
              </button>
              {mcqTest.testTypeId !== 1 && (
                <button
                  type="button"
                  className="tt-button tt-button-primary"
                  onClick={this.props.toggleMcqModal}
                >
                  Cancel
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default McqTestTemplate;
